import { Columns, Input } from 'lqx-react/lib';
import * as React from 'react';
import NumberFormat from 'react-number-format';
import { CustomerReferenceData, ManualCustomerReferenceData } from '../../api/customerReferenceData';
import { AssetColumn, StyledFormLabel, numberInputStyles } from '../../components/number-input';
import { DigiDateInput, ErrorHighligter, asTimelessLinkedDate } from '../../shared';

export const CustomerReferenceDataForm = ({ crd }: { crd: CustomerReferenceData | ManualCustomerReferenceData }) => {
    const classes = numberInputStyles();
    return <>
        <Columns>
            <AssetColumn>
                <StyledFormLabel>Unique Key</StyledFormLabel>
                <ErrorHighligter error={crd.errors['uniqueKey']}>
                    <Input data-qa-id="uniqueKey" $value={crd.$.uniqueKey} aria-label="Unique Key" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Customer Number</StyledFormLabel>
                <ErrorHighligter error={crd.errors['customerNumber']}>
                    <Input data-qa-id="customerNumber" $value={crd.$.customerNumber} aria-label="Customer Number" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Customer Name</StyledFormLabel>
                <ErrorHighligter error={crd.errors['customerName']}>
                    <Input data-qa-id="customerName" $value={crd.$.customerName} aria-label="Customer Name" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Country Code</StyledFormLabel>
                <ErrorHighligter error={crd.errors['countryCode']}>
                    <Input data-qa-id="countryCode" $value={crd.$.countryCode} aria-label="Country Code" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Effective Date</StyledFormLabel>
                <ErrorHighligter error={crd.errors['effectiveDate']}>
                    <DigiDateInput data-qa-id="effectiveDate" date $value={asTimelessLinkedDate(crd.$.effectiveDate)} />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Company Code</StyledFormLabel>
                <ErrorHighligter error={crd.errors['companyCode']}>
                    <Input data-qa-id="company code" $value={crd.$.companyCode} aria-label="Company Code" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Global Parent Code</StyledFormLabel>
                <ErrorHighligter error={crd.errors['globalParentCode']}>
                    <Input data-qa-id="globalParentCode" $value={crd.$.globalParentCode} aria-label="Global Parent Code" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Address 1</StyledFormLabel>
                <ErrorHighligter error={crd.errors['address1']}>
                    <Input data-qa-id="address1" $value={crd.$.address1} aria-label="Address 1" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Address 2</StyledFormLabel>
                <ErrorHighligter error={crd.errors['address2']}>
                    <Input data-qa-id="address2" $value={crd.$.address2} aria-label="Address 2" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Address 3</StyledFormLabel>
                <ErrorHighligter error={crd.errors['address3']}>
                    <Input data-qa-id="address3" $value={crd.$.address3} aria-label="Address 3" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>City</StyledFormLabel>
                <ErrorHighligter error={crd.errors['city']}>
                    <Input data-qa-id="city" $value={crd.$.city} aria-label="City" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>State</StyledFormLabel>
                <ErrorHighligter error={crd.errors['stateProvince']}>
                    <Input data-qa-id="stateProvince" $value={crd.$.stateProvince} aria-label="State" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Region Code</StyledFormLabel>
                <ErrorHighligter error={crd.errors['regionCode']}>
                    <Input data-qa-id="regionCode" $value={crd.$.regionCode} aria-label="Region Code" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Phone Number</StyledFormLabel>
                <ErrorHighligter error={crd.errors['phoneNumber']}>
                    <Input data-qa-id="phoneNumber" $value={crd.$.phoneNumber} aria-label="Phone Number" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Fax Number</StyledFormLabel>
                <ErrorHighligter error={crd.errors['faxNumber']}>
                    <Input data-qa-id="faxNumber" $value={crd.$.faxNumber} aria-label="Fax Number" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Email</StyledFormLabel>
                <ErrorHighligter error={crd.errors['email']}>
                    <Input data-qa-id="email" $value={crd.$.email} aria-label="Email" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Affiliate Flag</StyledFormLabel>
                <ErrorHighligter error={crd.errors['affiliateFlag']}>
                    <Input data-qa-id="affiliateFlag" $value={crd.$.affiliateFlag} aria-label="Affiliate Flag" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Government Flag</StyledFormLabel>
                <ErrorHighligter error={crd.errors['governmentFlag']}>
                    <Input data-qa-id="governmentFlag" $value={crd.$.governmentFlag} aria-label="Government Flag" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Assignability Flag</StyledFormLabel>
                <ErrorHighligter error={crd.errors['assignabilityFlag']}>
                    <Input data-qa-id="assignabilityFlag" $value={crd.$.assignabilityFlag} aria-label="Assignability Flag" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Credit Customer Flag</StyledFormLabel>
                <ErrorHighligter error={crd.errors['creditCustomerFlag']}>
                    <Input data-qa-id="creditCustomerFlag" $value={crd.$.creditCustomerFlag} aria-label="Credit Customer Flag" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Bankruptcy Flag</StyledFormLabel>
                <ErrorHighligter error={crd.errors['bankruptcyFlag']}>
                    <Input data-qa-id="bankruptcyFlag" $value={crd.$.bankruptcyFlag} aria-label="Bankruptcy Flag" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Customer Insurance Limit</StyledFormLabel>
                <ErrorHighligter error={crd.errors['customerInsuranceLimit']}>
                    <NumberFormat data-qa-id="customerInsuranceLimit" value={crd.customerInsuranceLimit} className={classes.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; crd.$.customerInsuranceLimit.set(floatValue) }} aria-label="Customer Insurance Limit" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Customer Credit Limit</StyledFormLabel>
                <ErrorHighligter error={crd.errors['customerCreditLimit']}>
                    <NumberFormat data-qa-id="customerCreditLimit" value={crd.customerCreditLimit} className={classes.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; crd.$.customerCreditLimit.set(floatValue) }} aria-label="Customer Credit Limit" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Customer VAT number</StyledFormLabel>
                <ErrorHighligter error={crd.errors['customerVATNumber']}>
                    <Input data-qa-id="customerVATNumber" $value={crd.$.customerVATNumber} aria-label="Customer VAT Number" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Notified Flag</StyledFormLabel>
                <ErrorHighligter error={crd.errors['notifiedFlag']}>
                    <Input data-qa-id="notifiedFlag" $value={crd.$.notifiedFlag} aria-label="Notified Flag" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Contact Name</StyledFormLabel>
                <ErrorHighligter error={crd.errors['contactName']}>
                    <Input data-qa-id="contactName" $value={crd.$.contactName} aria-label="Contact Name" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Duns Number</StyledFormLabel>
                <ErrorHighligter error={crd.errors['dunsNumber']}>
                    <Input data-qa-id="dunsNumber" $value={crd.$.dunsNumber} aria-label="DUNS Number" />
                </ErrorHighligter>
            </AssetColumn>
            <AssetColumn>
                <StyledFormLabel>Region</StyledFormLabel>
                <ErrorHighligter error={crd.errors['region']}>
                    <Input data-qa-id="region" $value={crd.$.region} aria-label="Region" />
                </ErrorHighligter>
            </AssetColumn>
        </Columns>
    </>
}